import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import useErrorHandler from './useErrorHandler';
import { closeLoading, showLoading } from '../../Reducer/LoadingReducer';
import { handleQuerySuccess } from './useQuriesSuccess';

/**
 * 공통 검색용 Mutation 훅
 *
 * 목적
 * - "조회지만 조건에 따라 실행"해야 하는 API를 useMutation으로 통일
 * - 일관된 로딩 표시(showLoading / closeLoading)
 * - 성공 시 공통 응답 처리(handleQuerySuccess)
 *
 * 특징
 * - 조회(useQuery)와 달리 자동 실행되지 않음
 * - run(params)를 호출해야 실제 API 요청 발생
 */
const useSearchMutaion = (mutationFn, successCallback = null) => {
  const dispatch = useDispatch();
  const { handleError } = useErrorHandler();
  const mutation = useMutation({
    mutationFn,

    onMutate: () => {
      dispatch(showLoading());
    },

    onError: async (error, variables, context) => {
      if (error.shouldShowDialog) {
        return;
      }

      await handleError(error, {
        url: error.config?.url,
        method: error.config?.method,
      });
    },

    onSettled: () => {
      dispatch(closeLoading());
    },
  });

  const run = (params, successOptions = null) => {
    mutation.mutate(params, {
      onSuccess: (response) => {
        handleQuerySuccess(response, successOptions ?? successCallback);
      },
    });
  };

  const runAsync = async (params, successOptions = null) => {
    const response = await mutation.mutateAsync(params);
    return handleQuerySuccess(response, successOptions ?? successCallback);
  };

  return { ...mutation, run, runAsync };
};

export default useSearchMutaion;
